<template lang="pug">
	
	div

		form
			div.form-group
				
				label.required Nome:
				
				input.form-control.form-control-sm(type="text", v-model="nome", name="nome", v-validate="'required'")
				
				input-errors(name="nome")

			div.form-group

				label.required Cor:

				color-palette(v-model="cor", name="cor", v-validate="'required'", @input="onCorChange")

				input-errors(name="cor")

			div.form-group
				
				label.required Arquivo shape:

				shape-input(ref="shapeInput"
					name="shape",
					v-model="geoJsonShape",
					v-validate="'required'",
					:max-file-size="10",
					@input="onShapeChange")

				input-errors(name="shape")

		div.row
			div.col-12.mt-2
					
				button.btn.btn-outline-secondary.btn-sm(type="button", @click="cancelar()")
					i.mdi.mdi-close
					|  Cancelar

				button.btn.btn-primary.btn-sm.float-right(type="button", 
						@click="adicionarCamadaShape()")
					i.mdi.mdi-check
					|  Adicionar

</template>

<script>

import LeafletUtils from '@/utils/leafletUtils';
import ShapeInput from '@/components/utils/ShapeInput';
import ColorPalette from '@/components/utils/ColorPalette';
import InputErrors from '@/components/utils/InputErrors';
import Estilo from '@/models/estilo';
import TipoGeometria from '@/models/tipoGeometria';
import DrawUtils from '@/utils/drawUtils';
import { mapMutations } from 'vuex';

export default {
	
	name: 'AdicaoCamadaShape',

	components: { ShapeInput, ColorPalette, InputErrors },

	data () {
		return {
			geoJsonShape: null,
			nome: '',
			cor: null,
			layer: null,
			style: null,
			tipoGeometria: TipoGeometria.POLIGONO
		};
	},

	methods: {

		limparCampos () {
			this.removerGeometriasMapa();
			this.cor = null;
			this.nome = null;
			this.geoJsonShape = null;
			this.layer = null;
			this.tipoGeometria = TipoGeometria.POLIGONO;
			this.$refs.shapeInput.clear();
			this.configureStyle();

			this.$nextTick().then(() => {
				this.$validator.cleanErrors();
			});
		},

		cancelar () {
			this.limparCampos();
			this.$emit('limpar');
		},

		adicionarCamadaShape () {

			this.$emit('limpar');

			this.$validator.validateAll().then((result) => {
					
				if (result) {
					
					this.$emit('adicionarCamada', {
						nome: this.nome,
						geoJson: this.geoJsonShape,
						cor: this.cor
					});

					this.limparCampos();
				}
			});
		},

		onCorChange () {

			if (this.layer) {
				
				this.configureStyle();
				this.layer.setStyle(this.style);
			}
		},
		
		configureStyle () {

			var cor = this.cor || DrawUtils.DEFAULT_COLOR;
			var estilo = Estilo.criarEstiloCamadaUsuario(cor, this.tipoGeometria);
			this.style = Estilo.toMapStyle(estilo, true);
		},

		removerGeometriasMapa () {

			if (this.layer) this.$bus.$emit('mapa.removeLayer', this.layer);
		},

		adicionarGeometriasMapa () {

			if (this.layer) this.$bus.$emit('mapa.addLayer', this.layer);
		},

		onShapeChange (geoJson) {

			this.removerGeometriasMapa();

			this.tipoGeometria = TipoGeometria.getFromGeoJson(geoJson);
			this.configureStyle();

			this.layer = LeafletUtils.createGeoJsonLayer(geoJson, this.style);

			this.layer.addTo(this.$mapa);
			this.$bus.$emit('mapa.centerLayer', this.layer);
		},

		...mapMutations([
			'adicionarCamadaUsuario',
			'ativarCamada'
		])
	}
};

</script>


// WEBPACK FOOTER //
// AdicaoCamadaShape.vue?57a015f3